import React from "react";
import SubDivisionForm from "./SubDivisionForm";

export default function SubDivisionAdd() {
  return <SubDivisionForm mode="add" />;
}
